<template>
    <div>
        <!-- <v-divider vertical v-if="leftDivider"></v-divider> -->
        <v-card elevation="0" class="pa-3">
            <div class="overline text-center">
                <v-icon dense left v-if="icon">
                    {{ icon }}
                </v-icon>

                {{ label }}
            </div>

            <v-card-text class="text-center pa-7">
                <span class="display-2 text--darken-1" v-bind:class="textColor">
                    {{ value }}
                </span>
                <br />
                <span v-if="sub !== null">
                    {{ sub }}
                </span>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: () => null,
        },
        leftDivider: {
            type: Boolean,
            default: () => false,
        },
        color: {
            type: String,
            default: () => 'green',
        },
        sub: {
            default: () => null,
        },
        subFormat: {
            type: String,
            default: () => null,
        },
    },

    computed: {
        textColor() {
            return this.color + '--text'
        },
    },
}
</script>
